import { buildAuthActionUrl, getAppOrigin } from "../config/domains";
import { isReservedRoute, normalizeRouteSegment } from "./reservedRoutes";

const LEGACY_ORGANIZATION_ALIASES = {
  "rccg-chapel-of-mercy": "the-redeemed-christian-church-of-god-chapel-of-mercy-00405731",
  "church-fundraising-rccg.web.app": "the-redeemed-christian-church-of-god-chapel-of-mercy-00405731",
};

const LEGACY_RCCG_HOSTS = new Set(["church-fundraising-rccg.web.app"]);
const RCCG_LEGACY_SLUG = "the-redeemed-christian-church-of-god-chapel-of-mercy-00405731";
const RCCG_SHORT_LEGACY_PATH = "/rccg-chapel-of-mercy";
const LEGACY_PARTICIPANT_PREFIX = "/participant";

export function normalizeOrganizationKey(value) {
  return String(value || "")
    .trim()
    .replace(/^\/+|\/+$/g, "")
    .toLowerCase();
}

export function resolveOrganizationAlias(value) {
  return LEGACY_ORGANIZATION_ALIASES[normalizeOrganizationKey(value)] || "";
}

export function getOrganizationLookupCandidates(value) {
  const raw = String(value || "").trim();
  const normalized = normalizeOrganizationKey(raw);
  const alias = resolveOrganizationAlias(raw);
  return Array.from(new Set([raw, normalized, alias].filter(Boolean)));
}

export function redirectLegacyRccgHost(locationLike = window.location) {
  const hostname = String(locationLike?.hostname || "").toLowerCase();
  if (!LEGACY_RCCG_HOSTS.has(hostname)) return false;

  const pathname = String(locationLike?.pathname || "/");
  const search = String(locationLike?.search || "");
  const hash = String(locationLike?.hash || "");
  const firstSegment = normalizeRouteSegment(pathname);
  const appOrigin = getAppOrigin(locationLike);
  const basePath = `/${RCCG_LEGACY_SLUG}`;
  let targetPath = basePath;

  if (
    pathname === "/auth" ||
    pathname.startsWith("/auth/") ||
    pathname === "/verify-email" ||
    pathname === "/reset-password" ||
    pathname === "/action"
  ) {
    window.location.replace(`${buildAuthActionUrl(locationLike)}${search}${hash}`);
    return true;
  }

  if (firstSegment && isReservedRoute(firstSegment)) {
    window.location.replace(`${appOrigin}${pathname}${search}${hash}`);
    return true;
  }

  if (pathname && pathname !== "/") {
    if (
      pathname === LEGACY_PARTICIPANT_PREFIX ||
      pathname.startsWith(`${LEGACY_PARTICIPANT_PREFIX}/`)
    ) {
      targetPath = pathname;
    } else if (pathname === basePath || pathname === RCCG_SHORT_LEGACY_PATH) {
      targetPath = basePath;
    } else if (pathname.startsWith(`${basePath}/`)) {
      targetPath = pathname;
    } else if (pathname.startsWith(`${RCCG_SHORT_LEGACY_PATH}/`)) {
      targetPath = `${basePath}${pathname.slice(RCCG_SHORT_LEGACY_PATH.length)}`;
    } else {
      targetPath = `${basePath}${pathname.startsWith("/") ? pathname : `/${pathname}`}`;
    }
  }

  window.location.replace(`${appOrigin}${targetPath}${search}${hash}`);
  return true;
}
